/**
 * TanStack Query hooks for `bulk-select-bulk-actions`. Thin wrappers over ./api.
 */
import {
	useMutation,
	useQuery,
	useQueryClient,
	type UseMutationResult,
	type UseQueryResult,
} from "@tanstack/react-query";
import {
	create,
	list,
	remove,
	bulkSelectBulkActionsQueryKeys,
	type CreateBulkSelectBulkActionsBody,
	type ListBulkSelectBulkActionsResponse,
	type BulkSelectBulkActionsRow,
} from "./api";

export function useBulkSelectBulkActionsList(): UseQueryResult<ListBulkSelectBulkActionsResponse, Error> {
	return useQuery({
		queryKey: bulkSelectBulkActionsQueryKeys.list(),
		queryFn: list,
	});
}

export function useBulkSelectBulkActionsCreate(): UseMutationResult<BulkSelectBulkActionsRow, Error, CreateBulkSelectBulkActionsBody> {
	const qc = useQueryClient();
	return useMutation({
		mutationFn: create,
		onSuccess: () => {
			qc.invalidateQueries({ queryKey: bulkSelectBulkActionsQueryKeys.all });
		},
	});
}

export function useBulkSelectBulkActionsDelete(): UseMutationResult<{ removed: boolean }, Error, string> {
	const qc = useQueryClient();
	return useMutation({
		mutationFn: remove,
		onSuccess: () => {
			qc.invalidateQueries({ queryKey: bulkSelectBulkActionsQueryKeys.all });
		},
	});
}
